define('modules/base/models/user.model',[
    'underscore',
    'backbone',
    'modules/base/models/base.model'
], function (_, Backbone, BaseModel) {
    var UserModel = BaseModel.extend({
        base: 'user',
        useLocalStorage: true,
        onlyUseLocalStorageOnPageLoad: true,
        fetch:function(options){
            if(this.has('id')){
                this.set({id: undefined});
            }
            BaseModel.prototype.fetch.call(this, options);
        }
    });
    return UserModel;
});

